import { VpButton } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'

interface SearchRetryAlertProps {
  testId: string
  onRetry: () => void
}

export function SearchRetryAlert({ testId, onRetry }: Readonly<SearchRetryAlertProps>) {
  const { t } = useTranslation()

  return (
    <div className="quick-search-results-page__error" role="alert" data-testid={testId}>
      <p>{t('quick-search.search-error')}</p>
      <VpButton variant="secondary" size="small" onClick={onRetry}>
        {t('quick-search.retry-search')}
      </VpButton>
    </div>
  )
}
